import React from "react";
import {
  Button,
  FormFieldSet,
  PageTitle,
  useFormHandler,
} from "../../../../../../components";

const AiRecruiterCall = () => {
  const initialFormData = {
    days: [],
    timeZone: "",
    fromTime: "",
    toTime: "",
    gapBetweenCalls: "",
  };

  const { formData, errors, handleChange, setFormData } = useFormHandler(
    initialFormData,
    {},
  );
  return (
    <div className="p-2">
      <PageTitle title={"AI Call Scheduling"} tag="h6" />
      <div className="my-3 mx-2 p-4 border border-gray-400 rounded bg-gray-50 ">
        <div className="grid grid-cols-5 gap-4">
          <div className="col-span-5">
            <FormFieldSet
              type="checkbox"
              title="Select days for schedule"
              multiple={true}
              options={[
                { label: "Monday", value: 1 },
                { label: "Tuesday", value: 2 },
                { label: "Wednesday", value: 3 },
                { label: "Thursday", value: 4 },
                { label: "Friday", value: 5 },
                { label: "Saturday", value: 6 },
                { label: "Sunday", value: 7 },
              ]}
              values={formData.days}
              onChange={(value) => handleChange("days", value)}
              error={errors.days}
            />
          </div>
          <div className="col-span-4">
            <FormFieldSet
              type="select"
              title="Time Zone"
              placeholder="Select"
              value={formData.timeZone}
              onChange={(value) => handleChange("timeZone", value)}
              error={errors.timeZone}
            />
          </div>
          <div className="col-span-2">
            <FormFieldSet
              type="select"
              title="From Time"
              placeholder="Select"
              value={formData.fromTime}
              onChange={(value) => handleChange("fromTime", value)}
              error={errors.fromTime}
            />
          </div>
          <div className="col-span-2">
            <FormFieldSet
              type="select"
              title="To Time"
              placeholder="Select"
              value={formData.toTime}
              onChange={(value) => handleChange("toTime", value)}
              error={errors.toTime}
            />
          </div>
          <div className="col-span-4">
            <FormFieldSet
              type="select"
              title="Gap Between Calls"
              placeholder="Select"
              value={formData.gapBetweenCalls}
              onChange={(value) => handleChange("gapBetweenCalls", value)}
              error={errors.gapBetweenCalls}
            />
          </div>
        </div>
        <div className="flex justify-end my-10 gap-3">
          <Button title={"Cancel"} variant="outlined" />
          <Button title={"Save"} />
        </div>
      </div>
    </div>
  );
};

export default AiRecruiterCall;
